<template>
  <v-container
    fluid
    grid-list-md
    row
    wrap
    style="width: 366px"
    class="pa-0"
    v-bind:class="isMobile ? 'mb-date-filter' : 'date-filter'"
  >
    <v-layout row wrap>
      <v-flex xs6>
        <h6 class="body-2 font-weight-black">Start Date</h6>
        <DatePicker :date="startDate" @date-update="this.onStartDateChange" :max-date="maxDate" />
      </v-flex>
      <v-flex xs6>
        <h6 class="body-2 font-weight-black">End Date</h6>
        <DatePicker :date="endDate" @date-update="this.onEndDateChange" :min-date="startDate" :max-date="today" />
      </v-flex>
      <v-flex xs12>
        <v-list rounded>
          <div
            class="option"
            :key="shortcut.id"
            v-for="shortcut in shortcuts"
            @click.prevent.stop="handleSelectShortcut(shortcut)"
            :class="{ active: isActiveShortcut(shortcut.id) }"
          >
            <div>{{ shortcut.name }}</div>
            <v-icon v-if="isActiveShortcut(shortcut.id)" color="white">
              check
            </v-icon>
          </div>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import DatePicker from "./Date";
import { Number, Object } from "lodash/_freeGlobal";
const formatDate = momDate => {
  return momDate.format("YYYY-MM-DD");
};

//#endregion
export default {
  name: "DateFilter",
  components: {
    DatePicker
  },
  props: {
    isMobile: Boolean,
    dateRange: Object,
    shortcutId: [String, Number, Object]
  },
  data() {
    return {
      startDate: this.dateRange.startDate,
      endDate: this.dateRange.endDate,
      selectedShortcutId: null,
      shortcuts: [
        {
          id: 0,
          name: "Today",
          getRange: () => ({
            startDate: formatDate(moment()),
            endDate: formatDate(moment())
          })
        },
        {
          id: 1,
          name: "Yesterday",
          getRange: () => ({
            startDate: formatDate(moment().subtract(1, "days")),
            endDate: formatDate(moment())
          })
        },
        {
          id: 2,
          name: "Last week",
          getRange: () => ({
            startDate: formatDate(moment().subtract(1, "weeks")),
            endDate: formatDate(moment())
          })
        },
        {
          id: 3,
          name: "Last Month",
          getRange: () => ({
            startDate: formatDate(moment().subtract(1, "months")),
            endDate: formatDate(moment())
          })
        }
      ]
    };
  },
  computed: {
    maxDate() {
      return !this.endDate || moment().isBefore(moment(this.endDate)) ? formatDate(moment()) : this.endDate;
    },
    today() {
      return formatDate(moment());
    }
  },
  methods: {
    handleSelectShortcut({ id, getRange }) {
      if (this.isActiveShortcut(id)) {
        this.selectedShortcutId = null;
        this.startDate = null;
        this.endDate = null;
      } else {
        const { startDate, endDate } = getRange();
        this.startDate = startDate;
        this.endDate = endDate;
        this.selectedShortcutId = id;
      }
    },
    emitChange() {
      //When manually selected todays Date
      if (this.startDate === formatDate(moment()) && this.endDate === formatDate(moment())) {
        this.selectedShortcutId = 0;
      }
      //When manually seleected yesterday
      else if (this.startDate === formatDate(moment().subtract(1, "days")) && this.endDate === formatDate(moment())) {
        this.selectedShortcutId = 1;
      }
      // When manually selected this weeks time range
      else if (this.startDate === formatDate(moment().subtract(1, "weeks")) && this.endDate === formatDate(moment())) {
        this.selectedShortcutId = 2;
      }
      // When manually selected this months's time range
      else if (this.startDate === formatDate(moment().subtract(1, "months")) && this.endDate === formatDate(moment())) {
        this.selectedShortcutId = 3;
      }
      this.$emit("date-change", {
        startDate: this.startDate,
        endDate: this.endDate,
        selectedShortcutId: this.selectedShortcutId
      });
    },
    onStartDateChange(startDate) {
      this.startDate = startDate;
      this.selectedShortcutId = null;
    },
    onEndDateChange(endDate) {
      this.endDate = endDate;
      this.selectedShortcutId = null;
    },
    isActiveShortcut(id) {
      return id === this.shortcutId;
    }
  },
  watch: {
    startDate() {
      this.emitChange();
    },
    endDate() {
      this.emitChange();
    }
  }
};
</script>

<style lang="scss" scoped>
.option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  cursor: pointer;

  &.active {
    background: #0066ff !important;
    color: white !important;
  }

  &:hover {
    background-color: rgba(204, 224, 255, 0.3);
    color: #0066ff;
  }
}
.mb-date-filter {
  width: 100% !important;
  .v-list {
    flex-wrap: wrap;
    display: flex;
  }
  .font-weight-black {
    font-family: "Montserrat" !important;
    font-style: normal;
    font-weight: 400 !important;
    font-size: 10px !important;
    line-height: 12px;
    color: #4d4d4d;
    margin-bottom: 5px;
  }
  .option {
    font-family: "Montserrat" !important;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    letter-spacing: 0.366667px;
    color: #0f6dfa;
    border-radius: 6px;
    border: 0.5px solid #0f6dfa;
    padding: 8px 20px;
    width: max-content;
    margin-bottom: 15px;
    margin-right: 5px;
    &.active {
      background: #0f6dfa;
      border-radius: 6px;
      color: #ffffff;
      display: inline-flex;
      align-items: center;
      > i {
        font-size: 12px;
        margin-left: 8px;
      }
    }
  }
}
</style>
